import {
    Component,
    EventEmitter,
    forwardRef,
    Input,
    OnChanges,
    Output,
    ViewChild,
} from '@angular/core';
import {
    ControlValueAccessor,
    FormControl,
    NG_VALIDATORS,
    NG_VALUE_ACCESSOR,
    NgForm,
} from '@angular/forms';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { Folder } from 'src/app/acl-data/folder/folder.dto';
import { FolderService } from 'src/app/acl-data/folder/folder.service';

import { DynamicObjectType } from '../dynamic-object-type.enum';
import { ISearchField } from '../search-field.interface';

@Component({
    selector: 'app-search-field',
    templateUrl: './search-field.component.html',
    styleUrls: ['./search-field.component.scss'],
    // changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SearchFieldComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: SearchFieldComponent,
            multi: true,
        },
    ],
})
export class SearchFieldComponent implements ControlValueAccessor, OnChanges {
    dynamicObjectType = DynamicObjectType;
    @Input() searchField: ISearchField;
    searchFieldCopy;
    @Input() objectStore: string;
    @Input() availableKeys: ISearchField[];
    @Output() typeChanged = new EventEmitter<ISearchField>();
    @Output() fieldDeleted = new EventEmitter<ISearchField>();

    @ViewChild(NgForm) myForm: NgForm;

    folders$: Observable<Folder[]>;
    folderCategory$;

    value;
    valueFrom;
    valueTo;

    valueLibrary: string;

    boSearch = '';
    keySearch = '';
    folderSearch = '';
    subFolderSearch = '';

    choices = [];
    selected = [];
    settings = {};
    onChanges = [];
    onTouched = [];
    touched = false;
    disabled = false;

    constructor(private folderService: FolderService) {
        console.log('Constructor');
    }

    public get invalid(): boolean {
        const result =
            (this.searchField.type === DynamicObjectType.Date &&
                (!this.valueFrom || !this.valueTo)) ||
            (this.searchField.type !== DynamicObjectType.Date &&
                (this.myForm.invalid ||
                    (!this.value && this.valueLibrary !== '/')));
        // console.log('Check inalid', result, this.value, this.valueLibrary);
        return result;
    }

    public get showError(): boolean {
        if (!this.myForm || !this.value) {
            return false;
        }

        const { dirty, touched } = this.myForm;

        return this.myForm.invalid
            ? this.myForm.dirty || this.myForm.touched
            : false;
    }

    public get errors() {
        if (!this.myForm) {
            return [];
        }

        return this.myForm.errors;
    }

    public get valid(): boolean {
        return !this.invalid;
    }

    validate({ value }: FormControl) {
        if (!value) {
            // console.log('Return null');
            return { nullValue: true };
        }
        // console.log('Call validate', this.invalid, this.myForm.controls.length);
        return this.invalid ? { searchFieldInvalid: true } : undefined;
    }

    ngOnChanges(SimpleChanges): void {
        this.searchFieldCopy = { ...this.searchField };
        if (!this.folders$ && this.objectStore) {
            this.folders$ = this.folderService.getRoot(this.objectStore);
            // .pipe(
            //     switchMap(v =>
            //         this.folderService
            //             .getByIds(
            //                 this.objectStore,
            //                 v.reduce(
            //                     (acc, row) => [...acc, ...row.subFolders],
            //                     []
            //                 )
            //             )
            //             .pipe(
            //                 map(v2 => [...v, ...v2]),
            //                 map(v =>
            //                     v.sort((a, b) =>
            //                         a.propertiesObj.PathName >
            //                         b.propertiesObj.PathName
            //                             ? 1
            //                             : -1
            //                     )
            //                 )
            //             )
            //     )
            // );
        }
    }

    private setOnChangeCallback(fn: any) {
        this.onChanges.push(fn);
    }

    private setOnTouchCallback(fn: any) {
        this.onTouched.push(fn);
    }

    setIsDisabled(isDisabled: boolean) {
        this.disabled = isDisabled;
    }

    writeValue(obj): void {
        // console.log('Writing', obj);
        // if (
        //     !!obj &&
        //     this.searchField &&
        //     this.searchField.type !== DynamicObjectType.Unknown
        // ) {
        //     console.log('Writing', obj);
        //     this.value = obj;
        // }
    }
    registerOnChange(fn: any): void {
        // console.log('registerOnChange');
        this.setOnChangeCallback(fn);
    }
    registerOnTouched(fn: any): void {
        this.setOnTouchCallback(fn);
    }
    setDisabledState?(isDisabled: boolean): void {
        this.setIsDisabled(isDisabled);
    }

    formChangedLibrary = (input: any) => {
        // console.log('formChangedLibrary', input);
        if (input === 'ALL') {
            this.value = '/';
            this.formChanged('/');
        } else {
            this.formChanged(input + '/ALL');
            console.log('Changed Library', input);
            this.folderCategory$ = this.folders$.pipe(
                // tap(v => console.log(v)),
                map(v =>
                    v.find(
                        row => row.propertiesObj.PathName === this.valueLibrary
                    )
                ),
                // tap(v => console.log(v)),
                switchMap(v =>
                    this.folderService
                        .getByIds(this.objectStore, v.subFolders)
                        .pipe(
                            map(v =>
                                v.sort((a, b) =>
                                    a.propertiesObj.PathName >
                                    b.propertiesObj.PathName
                                        ? 1
                                        : -1
                                )
                            )
                        )
                )
            );
        }

        for (const change of this.onChanges) {
            change(input);
        }
    };

    formChanged = (input: any) => {
        // console.log('Changed', input);
        if (
            this.searchField &&
            this.searchField.type === DynamicObjectType.Date
        ) {
            const dateChange = {
                from: this.valueFrom ? this.valueFrom.getTime() : 0,
                to: this.valueTo ? this.valueTo.getTime() : 0,
            };
            for (const change of this.onChanges) {
                change(dateChange);
            }
        } else {
            for (const change of this.onChanges) {
                change(input);
            }
        }

        this.markAsTouched();
    };

    formTouched = (input: any) => {
        this.touched = true;
        for (const touch of this.onTouched) {
            touch(input);
        }
    };

    markAsTouched() {
        // console.log('Mark as touched');

        const keys = Object.keys(this.myForm.controls);
        for (const key of keys) {
            this.myForm.controls[key].markAsTouched();
        }

        this.touched = true;
        this.formTouched({});
    }

    fieldChanged = (input: string) => {
        const newKey = this.availableKeys.find(v => v.name === input);
        // this.searchField = newKey;
        this.typeChanged.emit(newKey);
    };

    delete = () => {
        this.fieldDeleted.emit(this.searchField);
    };

    // showValue = (input: string) => {
    //     console.log(input, this.folderSearch);
    //     return (
    //         !this.folderSearch ||
    //         this.folderSearch.length === 0 ||
    //         input.toLowerCase().indexOf(this.folderSearch.toLowerCase()) >= 0
    //     );
    // };
}
